import { useMemo } from 'react'
import { PublicFullTrip, PublicMapItem } from 'tripPlanner/types/publicTrip'
import { MapItem } from 'tripPlanner/types/tripItem'
import { filterSavedItemsWithExplorePlaces } from 'tripPlanner/utils/explore'
import { TripTab } from 'tripPlanner/utils/tabs'
import { isRouteItem, mapTripItemToRoute, isPinnedItem, mapTripItemToMarker, isMapItem } from '../utils'
import { ExploreItem, FullTrip } from 'tripPlanner/types/common'
import { EmptyArray } from 'lib/array/arrayUtils'

const ROUTE_BOUNDS_EXCLUSION_TYPES = ['FLIGHT']

export default function useTripItemMapElements(trip: FullTrip | PublicFullTrip, tab: TripTab, exploreItems: Array<ExploreItem> = EmptyArray) {
  const items = useMemo(() => trip.items.filter(isMapItem) as Array<MapItem | PublicMapItem>, [trip.items])

  const allRoutes = useMemo(() => {
    const routeItems = items.filter(isRouteItem)
    return routeItems.map((routeItem) => mapTripItemToRoute(routeItem, tab === 'Explore' ? false : !ROUTE_BOUNDS_EXCLUSION_TYPES.includes(routeItem.type)))
  }, [items, tab])

  const allTripItemMarkers = useMemo(() => {
    const markerItems = items.filter(isPinnedItem)
    return markerItems.flatMap((markerItem) => mapTripItemToMarker(markerItem, tab !== 'Explore'))
  }, [items, tab])

  const allTripItemMarkersWithoutExplorePlaces = useMemo(() => {
    return filterSavedItemsWithExplorePlaces(allTripItemMarkers, exploreItems)
  }, [allTripItemMarkers, exploreItems])

  const allTripItemMapElements = useMemo(() => {
    return [
      ...allRoutes,
      ...allTripItemMarkersWithoutExplorePlaces,
    ]
  }, [allTripItemMarkersWithoutExplorePlaces, allRoutes])

  return allTripItemMapElements
}
